import React from 'react';
import styles from '../Styles/Navbar.module.css';
import { SignedIn,UserButton } from '@clerk/clerk-react'; 
import {Link} from 'react-router-dom';

const Navbar = () => {
    return (
        <nav className={styles.navbar}>
            <h1 className={styles.website_name}>Resume Builder</h1>

            <div className={styles.navlinks}>
                <Link to='/edit-template'>Resume Template</Link>
                <a href='/ChatGbt'> AI Powered Suggestions</a>
                <Link to='/Login'>Login</Link>
               
                <SignedIn>
                    <UserButton afterSignOutUrl='/' /> 
                </SignedIn>
            </div>
        </nav>
    );
};

export default Navbar;